import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="sidebar-toggle"
export default class extends Controller {
  static classes = ['toggled']

  toggleSidebar() {
    document.body.classList.toggle(this.toggledClass)
  }

  teardown() {
    document.body.classList.remove(this.toggledClass)
  }
}
